export default function ThreadSerializer(data){
    if(data)
    return {
        questionId:data.question_id,
        threadId: data.thread_id,
        menuId: data.menu_id,
        responseTime: data.response_time,
        stream_start:data.stream_start,
        questionType: data.question_type,
        question: data.question,
        answer: data.response ? data.response.answer:'',
        textSource: data.response ? data.response.text_src:[],
        imageSource: data.response? data.response.image_src:[],
        totalCost: data.response && data.response.cb_info.total_cost,
        totalTokens: data.response && data.response.cb_info.total_tokens,
        promptTokens: data.response && data.response.cb_info.prompt_tokens,
        completionTokens: data.response && data.response.cb_info.completion_tokens,
        responseStatus: data.response_received_status,
        feedback: data.user_feedback,
        tenant: data.tenant_id,
        category: data.category,
        comment: data.user_feedback_comment
    }
    return null
}